module.exports = __webpack_public_path__ + "img/host-it.0ddd2395.jpg";